import { defineMessages, type MessageDescriptor } from 'react-intl';

export const remixReadyMessages: Record<
	| 'remixReady'
	| 'remixReadyUpdated'
	| 'contentReady'
	| 'updateReady'
	| 'viewButton'
	| 'closeButton',
	MessageDescriptor
> = defineMessages({
	remixReady: {
		id: 'malleable-ui-components.remix.remix-ready-toast.remixReady',
		defaultMessage: 'Your remix is ready',
		description: 'Text shown when the remix is ready',
	},
	remixReadyUpdated: {
		id: 'malleable-ui-components.remix.remix-ready-toast.remixReady.updated',
		defaultMessage: 'Your content is ready',
		description: 'Text shown when the remix is ready',
	},
	contentReady: {
		id: 'malleable-ui-components.remix.remix-ready-toast.contentReady',
		defaultMessage: 'Your content is ready',
		description: 'Text shown when the created content is ready',
	},
	updateReady: {
		id: 'malleable-ui-components.remix.remix-ready-toast.updateReady',
		defaultMessage: 'Your edits are ready',
		description: 'Text shown when the update is ready',
	},
	viewButton: {
		id: 'malleable-ui-components.remix.remix-ready-toast.viewButton',
		defaultMessage: 'View',
		description: 'Text for the button to view the remix',
	},
	closeButton: {
		id: 'malleable-ui-components.remix.remix-ready-toast.closeButton',
		defaultMessage: 'Close',
		description: 'Text for the button to close the remix',
	},
});
